var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"info"},[_c('a',{staticClass:"beian",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("\n          \n            "+_vm._s(_vm.icp)+"\n        \n        ")])]),_vm._v(" "),(_vm.showdialog)?_c('vServicechat',{ref:"child"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ddf00f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-footer.vue
// module id = null
// module chunks = 